import React from 'react';

export const ExclamationIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        width="24"
        height="24"
    >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <line x1="12" y1="6" x2="12" y2="15" stroke="currentColor" strokeWidth="2" />
        <line x1="12" y1="17" x2="12" y2="18" stroke="currentColor" strokeWidth="2" />
    </svg>
);

export default ExclamationIcon;